/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { Container, Button, Modal, ModalTypical } from 'app/components';
import { useForm, useField } from 'react-final-form-hooks';
import { useConfig, useEffectFormReset, useModal } from 'app/hooks';
import { NavLink } from 'react-router-dom';
import ReCaptchaV2 from 'react-google-recaptcha';
import { useRef } from 'react';
import { useState } from 'react';
import TechnicConcession from '../components/TechnicConcession';
import PreferredDate from '../components/PreferredDate';
import AdditionalInfo from '../components/AdditionalInfo';
import { CinemaRentInquiryWrapper } from './styles';
import DataInputs from '../components/DataInputs';
import ProgramInput from '../components/ProgramInput';
import HallCapacity from '../components/HallCapacity';

const propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  cinemas: PropTypes.arrayOf(PropTypes.object).isRequired,
  notify: PropTypes.func.isRequired,
  validateWithSchema: PropTypes.func.isRequired,
  legalInfo: PropTypes.arrayOf(
    PropTypes.shape({
      doc: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    })
  ).isRequired,
  sendCinemaRentInquiry: PropTypes.func.isRequired,
  setLoader: PropTypes.func.isRequired,
  cinemaRentInquiryResult: PropTypes.array,
};

const CinemaRentInquiry = ({
  locations,
  cinemas,
  notify,
  validateWithSchema,
  legalInfo,
  sendCinemaRentInquiry,
  setLoader,
  cinemaRentInquiryResult
}) => {
  const [t] = useTranslation();
  const captchaRef = useRef(null);
  const [reCaptchaMsg, setReCaptchaMsg] = useState(null);
  const [recaptchaError, setRecaptchaError] = useState(null);

  // useEffect(() => {
  //   console.log("sitekey,secretKey", sitekey, secretKey);
  //   console.log("env.REACT_APP_SITE_KEY,env.REACT_APP_SECRET_KEY", process.env.REACT_APP_SITE_KEY, process.env.REACT_APP_SECRET_KEY);
  // }, [])

  async function verifyCaptcha(captcha) {
    const verifyEndpoint = "https://www.google.com/recaptcha/api/siteverify";
    try {
      const response = await fetch(verifyEndpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        },
        body: `secret=${process.env.REACT_APP_SECRET_KEY}&response=${captcha}`,
      });


      if (!response.ok) {
        throw new Error("Failed to verify CAPTCHA");
      }

      const data = await response.json();
      return data.success;
    } catch (error) {
      console.error("CAPTCHA verification failed:", error);
      return false;
    }
  }

  const handleRecaptcha = async () => {
    const token = captchaRef.current.getValue();
    try {
      const result = await verifyCaptcha(token);
      setReCaptchaMsg(result);
      setRecaptchaError("");
    } catch (error) {
      console.error("Error during CAPTCHA verification:", error);
      setRecaptchaError('CAPTCHA verification failed.');
    }
  }


  const handleExpired = () => {
    setRecaptchaError('Verification expired. Check the checkbox again.');
    setReCaptchaMsg(null)
    setTimeout(() => {
      captchaRef.current.reset();
    }, 100)
  };

  const sendInquiry = values => {
    captchaRef.current.reset();
    setReCaptchaMsg(null)
    const {
      state,
      cinema,
      phoneNumber,
      fax,
      firstName,
      lastName,
      email,
      company,
      department,
      street,
      zipCode,
      city,
      program,
      inclusiveType,
      filmTitle,
      privateParty,
      seminar,
      incentive,
      product,
      promotion,
      cultural,
      other,
      eventDescription,
      hall,
      headlight,
      video,
      radio,
      otherTechnic,
      wlan,
      headset,
      mixer,
      technicDescription,
      popcornSmall,
      popcornMedium,
      popcornLarge,
      popcornXlarge,
      softdrink,
      nachosSmall,
      nachosBig,
      otherConcession,
      concessionDescription,
      preferredDate,
      timeFrom,
      timeTo,
      message,
      attachment,
    } = values;

    const payload = {
      state: state?.[0]?.label || '',
      cinema: cinema?.[0]?.label || '',
      phonenumber: phoneNumber || '',
      fax: fax || '',
      firstname: firstName || '',
      lastname: lastName || '',
      email: email || '',
      companyPrivate: company || '',
      department: department || '',
      street: street || '',
      zip: zipCode || '',
      city: city || '',
      hallRentalFromcurrentprogram: inclusiveType?.includes('current'),
      hallRentalOwnfilm: inclusiveType?.includes('own'),
      hallRentalOwnfilmDescrib: filmTitle,
      hallRentalExclfilm: program === 'exclusiveFilms',
      privateBirthday: !!privateParty,
      seminar: !!seminar,
      incentive: !!incentive,
      // award,
      productpresentation: !!product,
      promotion: !!promotion,
      event: !!cultural,
      eventother: !!other,
      eventotherdescription: eventDescription || '',
      hall50: hall === 'up to 50',
      hall100: hall?.includes('100'),
      hall150: hall?.includes('150'),
      hall200: hall?.includes('200'),
      hall300: hall?.includes('300'),
      hall400: hall === 'up to 400',
      hallmore400: hall === 'more than 400',
      headlight: !!headlight,
      videoprojector: !!video,
      radiomicro: !!radio,
      wlan: !!wlan,
      headset: !!headset,
      mixer: !!mixer,
      technicother: !!otherTechnic,
      technicotherdescription: technicDescription || '',
      popcornsmall: !!popcornSmall,
      popcornmed: !!popcornMedium,
      popcornlarge: !!popcornLarge,
      popcornxlarge: !!popcornXlarge,
      drink: !!softdrink,
      nachossmall: !!nachosSmall,
      nachosbig: !!nachosBig,
      concessionother: !!otherConcession,
      concessionotherdescr: concessionDescription || '',
      preffereddate: preferredDate || '',
      timefrom: timeFrom ? format(timeFrom, 'HH:mm') : '',
      timeto: timeTo ? format(timeTo, 'HH:mm') : '',
      addinformation: message || '',
      attachment: attachment || ''
    };

    sendCinemaRentInquiry(payload);
  };
  const { routes, sitekey, secretKey } = useConfig();
  const {
    form,
    handleSubmit,
    submitErrors: errors,
    submitSucceeded,
    submitting,
    submitFailed,
    // errors: fieldErrors,
    // values
  } = useForm({
    onSubmit: sendInquiry,
    validate: validateWithSchema,
  });
  // Data
  const state = useField('state', form);
  const cinema = useField('cinema', form);
  const phoneNumber = useField('phoneNumber', form);
  const fax = useField('fax', form);
  const firstName = useField('firstName', form);
  const lastName = useField('lastName', form);
  const email = useField('email', form);
  const company = useField('company', form);
  const department = useField('department', form);
  const street = useField('street', form);
  const zipCode = useField('zipCode', form);
  const city = useField('city', form);

  // Program
  const program = useField('program', form);
  const inclusiveType = useField('inclusiveType', form);
  const filmTitle = useField('filmTitle', form);
  // const eventType = useField('eventType', form);

  const privateParty = useField('privateParty', form);
  const seminar = useField('seminar', form);
  const incentive = useField('incentive', form);
  const award = useField('award', form);
  const product = useField('product', form);
  const promotion = useField('promotion', form);
  const cultural = useField('cultural', form);
  const other = useField('other', form);

  const eventDescription = useField('eventDescription', form);

  // Hall Capacity
  const hall = useField('hall', form);

  // Technic Concession
  // const technic = useField('technic', form);
  const headlight = useField('headlight', form);
  const video = useField('video', form);
  const radio = useField('radio', form);
  const otherTechnic = useField('otherTechnic', form);
  const wlan = useField('wlan', form);
  const headset = useField('headset', form);
  const mixer = useField('mixer', form);

  const technicDescription = useField('technicDescription', form);
  const popcornSmall = useField('popcornSmall', form);
  const popcornMedium = useField('popcorMedium', form);
  const popcornLarge = useField('popcornLarge', form);
  const popcornXlarge = useField('popcornXlarge', form);
  const softdrink = useField('softdrink', form);
  const nachosSmall = useField('nachosSmall', form);
  const nachosBig = useField('nachosBig', form);
  const otherConcession = useField('otherConcession', form);
  const concessionDescription = useField('concessionDescription', form);

  // Preferred Date
  const preferredDate = useField('preferredDate', form);
  const timeFrom = useField('timeFrom', form);
  const timeTo = useField('timeTo', form);

  // Additional Information
  const message = useField('message', form);
  const attachment = useField('attachment', form);
  const attachmentName = useField('attachmentName', form);
  const terms = useField('terms', form);


  useEffectFormReset(form, errors, submitSucceeded, submitting);
  const dataInputProps = {
    state,
    cinema,
    phoneNumber,
    fax,
    firstName,
    lastName,
    email,
    company,
    department,
    street,
    zipCode,
    city
  };

  const programEventInputProps = {
    program,
    inclusiveType,
    filmTitle,
    privateParty,
    seminar,
    incentive,
    award,
    product,
    promotion,
    cultural,
    other,
    eventDescription
  };

  const hallInputProps = {
    hall
  };

  const technicConcessionInputProps = {
    headlight,
    video,
    radio,
    otherTechnic,
    wlan,
    headset,
    mixer,
    technicDescription,
    popcornSmall,
    popcornMedium,
    popcornLarge,
    popcornXlarge,
    softdrink,
    nachosSmall,
    nachosBig,
    otherConcession,
    concessionDescription
  };

  const preferrredDateInputProps = {
    preferredDate,
    timeFrom,
    timeTo
  };

  const additionalInformationInputProps = {
    message,
    attachment,
    attachmentName,
    terms
  };

  useEffect(() => {
    if (submitFailed) {
      notify('warning', t('cinema_rent_inquiry_form.validation_error'));
      // setTimeout(() => {
      //   window.location.reload();
      // }, 3000)
    }
  }, [submitFailed]);
  useEffect(() => {
    if (submitSucceeded) {
      showSuccess();
    }
  }, [submitSucceeded]);
  const getStateOptions = useCallback(() => {
    return locations?.map(({ id, name }) => ({ label: name, value: id }));
  }, [locations, state.input.value]);

  const getCinemaOptions = useCallback(() => {
    let cinemaList = cinemas?.map(({ id, name }) => ({ label: name, value: id }));

    if (state.input.value[0]?.value !== '' && locations?.length) {
      const locationItem = locations?.find(({ id }) => id === state.input.value[0]?.value);

      if (locationItem) {
        cinemaList = cinemas?.reduce((previous, current) => {
          if (locationItem?.items?.includes(+current?.id)) {
            return [...previous, { label: current?.name, value: current?.id }];
          }

          return [...previous];
        }, []);
      }
    }

    return cinemaList;
  }, [locations, cinemas, state.input.value]);

  const [isShowSuccess, showSuccess, hideSuccess] = useModal("success");

  return (
    <CinemaRentInquiryWrapper>
      <Container onSubmit={handleSubmit} as="form">
        <h2>{t('cinema_rent_inquiry_form.cinema_rent_inquiry')}</h2>
        <h2 className="cinema-rent__title">
          {t('cinema_rent_inquiry_form.cinema_rent_inquiry_title')}
        </h2>
        <h3>{t('cinema_rent_inquiry_form.cinema_rent_inquiry_subtitle')}</h3>
        <div className="cinema-rent__divider" />
        <DataInputs
          form={form}
          errors={errors}
          dataFields={dataInputProps}
          stateOptions={getStateOptions()}
          cinemaOptions={getCinemaOptions()}
          submitFailed={submitFailed}
        />
        <div className="cinema-rent__divider-sm" />
        <ProgramInput
          form={form}
          errors={errors}
          dataFields={programEventInputProps}
          submitFailed={submitFailed}
        />
        <div className="cinema-rent__divider-hall" />
        <HallCapacity
          form={form}
          errors={errors}
          dataFields={hallInputProps}
          submitFailed={submitFailed}
        />
        <div className="cinema-rent__divider-hall" />
        <TechnicConcession form={form} errors={errors} dataFields={technicConcessionInputProps} />
        <div className="cinema-rent__divider-date" />
        <PreferredDate submitFailed={submitFailed} form={form} errors={errors} dataFields={preferrredDateInputProps} />
        <div className="cinema-rent-divider-addition-info" />
        <AdditionalInfo
          form={form}
          errors={errors}
          dataFields={additionalInformationInputProps}
          submitFailed={submitFailed}
          legalInfo={legalInfo}
          notify={notify}
          setLoader={setLoader}
        />
        <div className="cinema-rent__divider-send" />
        <div className='captcha'>
          <ReCaptchaV2
            sitekey={process.env.REACT_APP_SITE_KEY}
            ref={captchaRef}
            onChange={() => handleRecaptcha()}
            theme="dark"
            onExpired={handleExpired}
          />
          {recaptchaError && <div style={{ color: 'red', marginTop: "10px" }}>{recaptchaError}</div>}
        </div>
        <Button type="submit" className="cinema-rent__send-btn" isPrimary disabled={!(
          additionalInformationInputProps?.terms?.input?.value.includes('terms and conditions') &&
          additionalInformationInputProps?.terms?.input?.value.includes('privacy policy')
          && !(reCaptchaMsg == null && !reCaptchaMsg)
        )}
        >
          {t('cinema_rent_inquiry_form.send_inquiry')}
        </Button>
      </Container>

      <Modal
        isSmall
        isOpen={isShowSuccess}
        // close={hideSuccess}
        title={t("common.success")}
      >
        <ModalTypical
          iconId="complete"
          title={t("common.reg_cinema_rent_inquiry")}
          message=""
        >

          <NavLink to={routes.movies.pattern} style={{ width: '100%' }}>
            <Button style={{ width: "200px" }} isPrimary onClick={hideSuccess}>
              {t("common.ok")}
            </Button>
          </NavLink>
        </ModalTypical>
      </Modal>
    </CinemaRentInquiryWrapper>

  );
};

CinemaRentInquiry.propTypes = propTypes;

export default CinemaRentInquiry;
